<template>
  <div class="pt">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t1">大模型智能开发平台</div>
          <div class="t2">
            大模型智能开发平台集大模型数据准备、训练、推理、部署应用于一体，提供数据生产、数据管理、模型管理以及计算资源管理等全栈管理产品，助力企业轻松拥抱大模型。
          </div>
          <div class="btns" @click="go('/callMe')">了解详情</div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="w1280">
        <div style="padding: 208px 0;">
          <div class="t3">助力企业轻松拥抱大模型</div>
          <div class="t4">
            大模型智能开发平台涵盖LLM开发全流程产品，包括数据生产、数据集管理、模型训练、算力管理模块，并提供一键部署功能，支持您快速进行大模型定制开发。
          </div>
        </div>
      </div>
    </div>
    <div class="card3">
      <div class="card3-t1">平台功能</div>
      <div style="display: flex;margin: 32px 0 64px;">
        <div
          class="btn-1"
          :class="indexs == 0 ? 'active' : ''"
          @click="indexs = 0"
        >
          <img
            v-if="indexs == 0"
            class="svg-img"
            src="../assets/img/pt/t1s.svg"
          />
          <img v-else class="svg-img" src="../assets/img/pt/t1.svg" />
          数据资产生产
        </div>
        <div
          class="btn-1"
          :class="indexs == 1 ? 'active' : ''"
          @click="indexs = 1"
        >
          <img
            v-if="indexs == 1"
            class="svg-img"
            src="../assets/img/pt/t2s.svg"
          />
          <img v-else class="svg-img" src="../assets/img/pt/t2.svg" />
          数据资产管理
        </div>
        <div
          class="btn-1"
          :class="indexs == 2 ? 'active' : ''"
          @click="indexs = 2"
        >
          <img
            v-if="indexs == 2"
            class="svg-img"
            src="../assets/img/pt/t3s.svg"
          />
          <img v-else class="svg-img" src="../assets/img/pt/t3.svg" />
          模型管理模块
        </div>
        <div
          class="btn-1"
          :class="indexs == 3 ? 'active' : ''"
          @click="indexs = 3"
        >
          <img
            v-if="indexs == 3"
            class="svg-img"
            src="../assets/img/pt/t4s.svg"
          />
          <img v-else class="svg-img" src="../assets/img/pt/t4.svg" />
          计算资源管理
        </div>
      </div>
      <div class="cards">
        <div class="flexs">
          <div style="width: 45%;">
            <div
              v-for="(item, index) in cardList[indexs].textList"
              :key="index"
            >
              <div class="text1">{{ item.title }}</div>
              <div class="text2">{{ item.content }}</div>
            </div>
          </div>
          <div style="width: 45%;">
            <img style="width:100%;" :src="cardList[indexs].img" />
          </div>
        </div>
      </div>
    </div>
    <div class="card3">
      <div class="card3-t1">大模型行业应用</div>
      <div class="flexs" style="flex-wrap: wrap;">
        <div
          v-for="(item, index) in cardList1"
          :key="index"
          class="img-card"
          :style="{ backgroundImage: `url(${item.img})` }"
          @mouseenter="item.status = false"
          @mouseleave="item.status = true"
        >
          <div class="floor">
            <div class="text1" v-if="item.status">{{ item.title }}</div>
            <div class="text1" v-else>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card3">
      <div class="card3-t1">平台优势</div>
      <div class="flexs" style="flex-wrap: wrap;margin: 0 200px;">
        <div class="img-card-2" v-for="(item, index) in cardList2" :key="index">
          <img style="width: 80px;" :src="item.img" />
          <div class="t1">{{ item.title }}</div>
          <div class="t2">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="t1">轻松拥抱大模型</div>
      <div class="t2">多管理模块助您快速部署大模型应用</div>
      <div class="btns" @click="go('/callMe')">预约演示</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      indexs: 0,
      cardList2: [
        {
          title: "高效的数据生产",
          content: "精心打磨的标注工具及流程，训练语料生产不再困难。",
          img: require("../assets/img/pt/q1.svg"),
        },
        {
          title: "全链路的功能覆盖",
          content:
            "数据生产，模型微调，模型评估，一键部署，一站式解决大模型开发。",
            img: require("../assets/img/pt/q2.svg"),
        },
        {
          title: "低成本的模型训练",
          content:
            "更低的数据准备成本，更优的算力资源调度，让大模型训练更具成本效益。",
            img: require("../assets/img/pt/q3.svg"),
        },
        {
          title: "优质的平台服务",
          content:
            "支持平台功能定制，灵活的部署方案，提供数据生产服务，为您打造专属高效的使用体验。",
            img: require("../assets/img/pt/q4.svg"),
        },
      ],
      cardList1: [
        {
          title: "金融",
          content:
            "更快同步产品、优惠、促销和资格标准的更新，改善客户体验和客户服务效率",
          img: require("../assets/img/pt/y1.png"),
          status: true,
        },
        {
          title: "医疗健康",
          content:
            "更早准确地识别医疗问题，协助放射科医生发现异常情况、识别特定情况并提高诊断准确性",
          img: require("../assets/img/pt/y2.png"),
          status: true,
        },
        {
          title: "电子商务",
          content: "分析客户数据以定制推荐并改进搜索以提高参与度和销量",
          img: require("../assets/img/pt/y3.png"),

          status: true,
        },
        {
          title: "保险&理财",
          content: "审查数据以自动处理索赔，提供个性化产品，以及风险评估",
          img: require("../assets/img/pt/y4.webp"),
          status: true,
        },
        {
          title: "线下零售",
          content: "通过个性化的对话式购物体验，增加销售额并提高客户满意度",
          img: require("../assets/img/pt/y5.webp"),
          status: true,
        },
        {
          title: "市场营销",
          content: "高效创建定制广告文案和编辑内容",
          img: require("../assets/img/pt/y6.webp"),
          status: true,
        },
        {
          title: "法律",
          content: "自动文档审查和生成、合同分析和研究，节省时间并降低成本",
          img: require("../assets/img/pt/y7.webp"),
          status: true,
        },
        {
          title: "社交媒体",
          content:
            "生成最新趋势&品牌内容，个性化消息传递，并创建适合平台的自动回复",
          img: require("../assets/img/pt/y8.webp"),
          status: true,
        },
        {
          title: "客服",
          content: "提供人工智能接口来处理客户查询并自动执行日常任务",
          img: require("../assets/img/pt/y9.webp"),
          status: true,
        },
        {
          title: "建筑业",
          content: "通过分析生产记录和事件报告来优化供应链运营，以提高质量控制",
          img: require("../assets/img/pt/y10.webp"),
          status: true,
        },
      ],
      cardList: [
        {
          textList: [
            {
              title: "标注工具",
              content:
                "平台提供完整的标注工具，可根据不同阶段数据需求，灵活配置工具，包括：语料自动生成，多模态语料人工编辑，结果排序，结果评价，结果错误标记，自定义语料属性等标注工作。",
            },
            {
              title: "工作流引擎",
              content:
                "闽江智能数据标注产业基地丰富的项目管理经验打磨出的强大工作流，可根据项目要求，便捷地配置标注、质检流程，并支持查看每个节点的详尽数据统计，确保数据高效高质量交付。",
            },
            {
              title: "自动标注算法",
              content:
                "大模型智能开发平台集成了 zqLinx AI 的 AI 辅助标注功能，并专门开发了内容评价，内容改写等利于大语言模型微调的自动标注算法。",
            },
          ],
          img: require("../assets/img/pt/s1.png"),
        },
        {
          textList: [
            {
              title: "数据处理",
              content:
                "数据处理工具内置数据有效性判断、数据聚类等算法，助力高效的数据处理工作。",
            },
            {
              title: "数据分析",
              content:
                "数据分析模块对数据集统计分析，可直观了解数据分布并进行优化。",
            },
            {
              title: "数据检索",
              content:
                "数据检索功能包含检索算法，支持多个检索维度，可在大批量的数据中，快速找到目标数据。",
            },
          ],
          img: require("../assets/img/pt/s2.png"),
        },
        {
          textList: [
            {
              title: "模型微调",
              content:
                "平台支持多种微调方法，并且内置微调任务管理功能，直观管理微调进度。",
            },
            {
              title: "模型评估",
              content:
                "平台内置多种评估工具，可以分析模型的不同优缺点，并进行多模型间的比较，及时发现模型的潜在问题。",
            },
            {
              title: "模型部署",
              content:
                "平台内置一键部署功能，可将训练好的算法一键部署为服务，或一键打包为 SDK，并通过标准API对外提供服务。",
            },
          ],
          img: require("../assets/img/pt/s3.png"),
        },
        {
          textList: [
            {
              title: "计算任务管理",
              content:
                "统一的管理界面，包含训练任务及推理任务，可以根据需求对任务设置优先级，并监控计算任务的运行情况。",
            },
            {
              title: "计算资源调度",
              content:
                "界面中直观显示计算资源状态，并可根据计算任务优先级和计算资源空闲情况，自动调度计算任务运行。",
            },
          ],
          img: require("../assets/img/pt/s4.png"),
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.pt {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 536px;
  }
  .card2 {
    width: 100%;
    height: 538px;
    background-color: #045588;
  }
  .card-footer{
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1{
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2{
      text-align: center;
      margin-top: 24px;
    }
    .btns{
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(260.38deg, #099fee 3.89%, #2247da 143.13%);
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .card3 {
    width: 1280px;
    margin: 56px auto;
    .img-card-2{
      margin-top: 40px;
      width: 400px;
      text-align: center;
      
      .t1{
        color: rgb(37, 39, 42);
        font-weight: 500;
        font-size: 20px;
        margin-top: 24px;
      }
      .t2{
        color:rgb(75, 79, 84);
        font-size: 16px;
        margin-top: 24px;
      }
    }
    .img-card {
      width: 208px;
      height: 208px;
      padding: 14px;
      position: relative;
      flex-shrink: 0;
      margin-bottom: 24px;

      .floor {
        background-color: rgba(9, 159, 238, 0.34);
        width: 236px;
        height: 236px;
        position: absolute;
        top: 0;
        left: 0;
        &:hover {
          background-color: rgba(9, 159, 238, 0.7);
        }
      }
      .text1 {
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 208px;
        margin: 0 auto;
        text-align: center;
      }
    }
    .cards {
      padding: 56px 48px;
      border: 2px solid rgba(48, 58, 84, 0.2);
      border-radius: 24px;
      height: 432px;
      .text1 {
        color: #045588;
        font-size: 24px;
        line-height: 2;
        font-weight: bold;
      }
      .text2 {
        font-size: 16px;
        line-height: 1.5;
        color: rgba(75, 79, 84, 0.75);
        margin-bottom: 20px;
      }
    }
    .card3-t1 {
      text-align: center;
      color: #045588;
      font-size: 48px;
      font-weight: bold;
      margin-bottom: 48px;
    }
    .btn-1 {
      width: 200px;
      height: 32px;
      padding: 16px 32px;
      background-color: #eceff0;
      border-radius: 32px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 32px;
      margin-right: 16px;
      font-size: 24px;
      cursor: pointer;
    }
    .active {
      background-color: #045588 !important;
      color: #fff !important;
    }
    .svg-img {
      margin-bottom: -5px;
      margin-right: 5px;
      fill: #045588;
    }
    .svg-img g {
      fill: #045588;
    }
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t1 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t2 {
      margin: 32px 248px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .t3 {
      color: #fff;
      font-size: 20px;
      text-align: center;
      margin-bottom: 32px;
    }
    .t4 {
      font-size: 20px;
      color: rgba($color: #fff, $alpha: 0.75);
      text-align: center;
      width: 760px;
      margin: 0 auto;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      color: #fff;
      font-size: 16px;
      padding: 12px 32px;
      border-radius: 6px;
      width: 100px;
      margin: 40px auto 0;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
